<div class="flex gap-[24px] flex-col">
  <app-power-limitation-history-filters
    [powerLimitationAmount]="powerLimitationHistoryStore.powerLimitationAmount$ | async"
    [consumptionLimitationAmount]="powerLimitationHistoryStore.consumptionLimitationAmount$ | async"
    [productionLimitationAmount]="powerLimitationHistoryStore.productionLimitationAmount$ | async"
    [controlCommandFilterType]="powerLimitationHistoryStore.controlCommandFilterType$ | async"
    [isLoading]="powerLimitationHistoryStore.loading$ | async"
  ></app-power-limitation-history-filters>
  <app-power-limitation-history-list
    [filteredData]="powerLimitationHistoryStore.filteredData$ | async"
    [isLoading]="powerLimitationHistoryStore.loading$ | async"
  ></app-power-limitation-history-list>
</div>
